import { Injectable } from "@angular/core";
import { map, Observable, Subject, switchMap, ReplaySubject, interval, takeWhile, of, share } from "rxjs";

import { AuthTransactionConfigService } from "./auth-transaction.config";

@Injectable({
	providedIn: "root",
})
export class AuthTransactionTimingsService {
	countdownInterval$: Subject<number | undefined> = new ReplaySubject<number | undefined>(1);

	countdown$: Observable<number> = this.countdownInterval$.pipe(
		switchMap((ms) => {
			if (!ms) {
				return of(this.config.getTransactionTimeout());
			}
			return interval(ms).pipe(
				map((value) => this.config.getTransactionTimeout() - (value + 1) * 1000),
				takeWhile((value) => value >= -1)
			);
		}),
		share()
	);

	constructor(private config: AuthTransactionConfigService) {}
}
